import { errorLocals } from 'src/locals';
import { drawenLayerService } from 'src/app/services';
import { statusHelper, geoJsonSocketHelper, hymotsLogsSocketHelper } from '.';

export interface DrawGeoFilterMap {
  tarafId: number | undefined;
  userRole: string | undefined;
}
export interface EditModeFeatureGroup {
  action: 'DELETE' | 'UPDATE' | 'SINGLE';
  json: any;
  id?: number;
  uuid?: string;
  deleteIdList?: string[];
}
export interface DrawenLayerResultType {
  id: number;
  uuid: string;
  features: any;
  tarafId?: number;
  isPrivate?: boolean;
}

export interface DrawenLayerCreateType {
  name: string;
  features: any;
  tarafId?: number;
  drawenLayerGroupIds: number[];
}

export interface DrawenLayerEditType {
  uuid: string;
  features?: any;
  name?: string;
}

export interface DrawenLayerBulkDeleteType {
  uuidArray: string[];
}

export type DrawenLayerSocketEvent =
  | DrawenLayerSocketCreateEventResult
  | DrawenLayerSocketUpdateEventResult
  | DrawenLayerSocketDeleteEventResult
  | DrawenLayerSocketDeleteManyEventResult
  | DrawenLayerSocketCopyEventResult
  | DrawenLayerPrivilegesUpdateEventResult;

export type DrawenLayerSocketCreateEventResult = {
  status: 'ADD';
  data: DrawenLayerResultType;
  drawenLayerGroupIds: number[];
};

export type DrawenLayerSocketUpdateEventResult = {
  status: 'UPDATE';
  data: DrawenLayerResultType;
};

export type DrawenLayerSocketDeleteEventResult = {
  status: 'DELETE';
  data: string;
};

export type DrawenLayerSocketDeleteManyEventResult = {
  status: 'DELETEMANY';
  data: string[];
  drawenLayerGroupIds?: number[];
};

// COPY LAYER GROUP
export type DrawenLayerSocketCopyEventResult = {
  status: 'COPY';
  data: any;
  drawenLayerGroupIds: number[];
};

export type DrawenLayerPrivilegesUpdateEventResult = {
  status: 'UPDATEPRIVILEGES';
  data: any;
  drawenLayerGroupIds: number[];
  tarafId: number;
};

const deleteDrawGeoJson = async (uuid: string) => {
  try {
    await drawenLayerService.drawenLayerDelete(uuid);
  } catch (error) {
    if (error !== errorLocals.errorHandledError) {
      statusHelper.displayErrorMessage('Failed to remove layer');
    }
  }
};

const deleteDrawGeoJsonArray = async (uuidArray: string[]) => {
  try {
    await drawenLayerService.drawenLayerDeleteMany({ uuidArray });
  } catch (error) {
    if (error !== errorLocals.errorHandledError) {
      statusHelper.displayErrorMessage('Failed to remove layers');
    }
  }
};

const updateDrawGeoJson = async (json: any, uuid: string) => {
  try {
    const res = await drawenLayerService.drawenLayerEdit({
      uuid,
      features: json,
    });

    return res.data;
  } catch (error) {
    if (error !== errorLocals.errorHandledError) {
      statusHelper.displayErrorMessage('Failed to update layer');
    }
  }
};

const updateDrawName = async (uuid: string, name: string) => {
  try {
    await drawenLayerService.drawenLayerEdit({
      uuid,
      name,
    });
  } catch (error) {
    if (error !== errorLocals.errorHandledError) {
      statusHelper.displayErrorMessage('Failed to update layer name');
    }
  }
};

const createGeoJsonSocketConnection = async (
  drawenLayerSocketCallbackCreate: (data: any) => void,
  drawenLayerSocketCallbackUpdateDelete: (data: any) => void,
  veritabaniId: number,
  tarafId?: number,
) => {
  const conStringCreate = `drawen-layer_${veritabaniId}${tarafId ? `_${tarafId}` : ``}`;
  const conStringUpdateDelete = `drawen-layer_${veritabaniId}`;

  hymotsLogsSocketHelper.listenSocket(conStringCreate, drawenLayerSocketCallbackCreate);
  hymotsLogsSocketHelper.listenSocket(conStringUpdateDelete, drawenLayerSocketCallbackUpdateDelete);
};

export { deleteDrawGeoJson, deleteDrawGeoJsonArray, updateDrawGeoJson, createGeoJsonSocketConnection, updateDrawName };
